import { API } from './resources'

export default {
  getRules: () => {
    return API.get('/spam/rules')
  },
  getReport: (id) => {
    return API.get(`/spam/report/${id}`)
  },
  addRule: (data) => {
    return API.post('/spam/rules', data)
  },
  updateRule: (id, data) => {
    return API.put(`/spam/rules/${id}`, data)
  },
  deleteRule: (id) => {
    return API.delete(`/spam/rules/${id}`)
  },
  addUserRule: (username) => {
    return API.post(`/spam/rules/${username}`)
  }
}
